export default "__VITE_ASSET__EGgIuQyJ7cAhs5XTHUTd2Q__"